export default __webpack_public_path__ + "img/10.f918d3.png";